module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="temp-slider"><label for="temp-alert-enabled">{{ tc(\'ControlHomeAlerts\', \'Temperature alert:\') }}</label><div class="input" id="temp-alert-enabled"><defa-radio-strip v-model="temperatureSwitchValue" :options="temperatureSwitchOptions" v-bind:class="{ errorState: model.alarmMask === null}" v-on:input="save($event, \'alarmMask\')"></div><dl v-show="model.modelError || model.alarmMaskError"><dd><p class="error">ERROR! {{ model.modelError || model.alarmMaskError }}</p></dd></dl></div>';
}
return __p;
};
